import * as Types from 'Types'
import BaseTreeNode from './BaseTreeNode'
import { store } from '~/Store'
import { InlineKeyEditor, TransformAttrToRel } from 'Components'
import { createRoot, TransformationButtons, getCurrentTimeInMillis, getIcon, getIds } from './shared'
import { getAttributeKeyLabel } from 'Services/WeaverUtils'
import { setCurrentItem } from 'Actions/explore'

getAttributes = (props) ->
  { branches: { currentBranch }} = store.getState()
  attributes = await Weaver.MetaQueries.attributesCount({ limit: 99999, branch: currentBranch or 'main' })
  attributes.map(({ key, count }) -> attributeTreeNode(key, count, props))

export attributesRoot = createRoot('Attributes', Types.ATTRIBUTES, 'all_attributes', getAttributes, Types.USERMODES.EXPERT)

export attributeTreeNode = (key, count, props) -> {
  key
  path: "all_attributes/#{key}"
  selectable: true
  isLeaf: true
  title: (
    <TransformationButtons
      transformComponents={[InlineKeyEditor, TransformAttrToRel]}
      type={Types.ATTRIBUTE_VIEW}
      label="#{getAttributeKeyLabel(key)}"
      count={count}
    />
  )
  type: Types.ATTRIBUTE_VIEW
  hasCtxMenu: false
}

export default {
  [Types.ATTRIBUTE_VIEW]: (node) ->
    store.dispatch(setCurrentItem({
      id: node.key
      type: Types.ATTRIBUTE_VIEW
      viewType: Types.VIEWTYPE.ABSTRACT
      ranAt: getCurrentTimeInMillis()
    }))
}
